import { Component, OnInit, Input } from '@angular/core';
import { from, Observable } from 'rxjs';
import { combineAll, map } from 'rxjs/operators';
import { Globals } from './../globals'
import { start } from 'repl';
//import { ISasToken } from '../services/azure-storage/azureStorage';
//import { BlobStorageService } from '../services/azure-storage/blob-storage.service';

//interface IUploadProgress {
//  filename: string;
//  progress: number;
//}

@Component({
  selector: 'app-upload-files',
  templateUrl: './upload-files.component.html'
})
export class UploadFilesComponent implements OnInit {

  @Input()
  email: string;

  @Input()
  numberchasis: string;

  @Input()
  ConsultarShow: boolean;

  @Input()
  origen: string;

  constructor(private globals: Globals) {
  }

  ngOnInit() {
    var algo = this.email;
    var algo2 = this.ConsultarShow;
    this.pauseTimer();
    this.globals.verarchivos = false;
    this.startTimer();
  }

  timeLeft: number = 60;
  interval;

  startTimer() {
    this.interval = setInterval(() => {
      this.globals.verarchivos = false;
      this.globals.verarchivos = true;
    }, 1000)
  }

  pauseTimer() {
    clearInterval(this.interval);
  }

}
